import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { AZURE_COOKIE_NAME, AZURE_TOKEN_SILENT_INTERVAL } from '../constants';
import utils from '../utils';

function SessionManagement() {
  const { instance, accounts } = useMsal();

  async function acquireTokenSilent() {
    try {
      await instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        })
        .then((response) => {
          const cookieValue = utils.getCookieByName(AZURE_COOKIE_NAME);
          if (cookieValue !== response.accessToken) {
            utils.setCookie();
          }
        });
    } catch (error) {
      await instance.acquireTokenRedirect({ ...loginRequest, account: accounts[0] });
    }
  }

  useEffect(() => {
    const tokenRenewalInterval = setInterval(acquireTokenSilent, AZURE_TOKEN_SILENT_INTERVAL);

    return () => {
      clearInterval(tokenRenewalInterval);
    };
  }, [instance, accounts]);

  return null;
}

export default SessionManagement;
